(() => {
  const initializedRows = new WeakSet();

  function updateMedia(section, row) {
    const desktopImageUrl = row.dataset.image;
    if (!desktopImageUrl) return;

    const mobileImageUrl = row.dataset.imageMobile || desktopImageUrl;

    const image = section.querySelector('.media-block img, .media-block [data-media-img]');
    if (!(image instanceof HTMLImageElement)) return;

    let picture = image.closest('picture');
    if (!picture) {
      picture = document.createElement('picture');
      picture.style.display = 'contents';
      image.before(picture);
      picture.append(image);
    }

    let mobileSource = picture.querySelector('source[data-accordion-media-source]');
    if (!mobileSource) {
      mobileSource = document.createElement('source');
      mobileSource.dataset.accordionMediaSource = '';
      mobileSource.media = '(max-width: 749px)';
      picture.prepend(mobileSource);
    }

    mobileSource.srcset = mobileImageUrl;
    mobileSource.sizes = '100vw';

    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.src = desktopImageUrl;
  }

  function initializeAccordion(accordion, section) {
    const rows = [...accordion.querySelectorAll('[data-accordion-row]')];
    if (!rows.length) return;

    const openRows = rows.filter((row) => row.open);
    openRows.slice(1).forEach((row) => {
      row.open = false;
    });

    const activeRow = openRows[0];
    if (activeRow) updateMedia(section, activeRow);

    rows.forEach((row) => {
      if (initializedRows.has(row)) return;
      initializedRows.add(row);

      row.addEventListener('toggle', () => {
        if (!row.open) return;

        rows.forEach((otherRow) => {
          if (otherRow !== row && otherRow.open) otherRow.open = false;
        });

        updateMedia(section, row);
      });
    });
  }

  function initializeSection(section) {
    if (!(section instanceof HTMLElement) || !section.classList.contains('media-with-content')) return;

    section.querySelectorAll('.accordion').forEach((accordion) => {
      initializeAccordion(accordion, section);
    });
  }

  function initialize(root = document) {
    if (root instanceof HTMLElement && root.classList.contains('media-with-content')) {
      initializeSection(root);
    }

    root.querySelectorAll?.('.media-with-content').forEach(initializeSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();
